export const PAYMENT_SETUP_URL = '/settings?tab=advanced&focus=payments';

export function needsPaymentSetup(status) {
  if (!status) return false; // Unknown status is not an outstanding task.
  if (!status.connected) return true;
  // Payouts may be paused independently while accepting payments still works.
  return status.status !== 'active' && status.charges_enabled !== true;
}

export function onlinePaymentsAvailable(subscription) {
  return Boolean(subscription && (subscription.feature_flags?.online_payments
    || ['starter', 'growth', 'business', 'pro'].includes(String(subscription.plan || '').toLowerCase())));
}
